import {useContext, useEffect} from "react";
import AppContext from "../../../AppContext";
import {useTranslation} from "react-i18next";

window.loadedImages = 0
window.loadingImages = false;
function Page1({ sim, setSim }) {
    const { t, i18n } = useTranslation();
    const app = useContext(AppContext);

    useEffect(() => {
        if(!window.loadingImages && sim.totalImages?.length > 0) {
            window.loadingImages = true;
            sim.totalImages.forEach((img, i) => {
                let image = new Image();
                image.onload = (e) => {
                    //console.log('loaded', img);
                    window.loadedImages++;
                    setSim({...sim, imagesLoaded: window.loadedImages })
                }
                image.src = img;
            })
            //console.log('loading images!');
        }
    }, [sim.totalImages, sim.imagesLoaded])

    let required_score = 50
    switch(app.user?.current_course) {
        case 1:
            required_score = 44
            break
        case 2:
            required_score = 41
            break
        case 3:
            required_score = 43
            break
    }

    return (
        <div className="exam-sim-page-1">
            <h1>{t('sim.page1.title')}</h1>
            <p>
                {t('sim.page1.text1', { required_score: required_score })}
            </p>
            <p>
                <strong>
                    {t('sim.page1.text2')}
                </strong>
            </p>
            {sim.questions?.length > 0 ? <>{sim.totalImages?.length > 0 && sim.imagesLoaded < sim.totalImages?.length ?
                <div className="exam-sim-page-1-loading">
                    <span>{t('sim.page1.loading', { completed: sim.imagesLoaded, count: sim.totalImages.length})}</span>
                    <div className="exam-sim-page-1-loading-progress">
                        <div style={{ width: Math.round((sim.imagesLoaded / sim.totalImages.length) * 100) + '%'}}></div>
                    </div>
                </div> :
                <>
                    <p>
                        {t('sim.page1.text3')}
                    </p>
                    <p>
                        {t('sim.page1.text4')}
                    </p>
                    <div className="exam-sim-page-1-bottom">
                        {t('sim.page1.text5')}
                    </div>
                </>
              }</> : <>
                <p><strong>{t('sim.page1.text6')}</strong></p>
            </>}
        </div>
    );
}
export default Page1;
